// Text area remains in place on page refresh 

const textArea = document.getElementById('cart_notes');
const submitButton = document.getElementById('cart_submit');

if (localStorage.getItem('savedText')) {
    textArea.value = localStorage.getItem('savedText');
}

textArea.addEventListener('input', () => {
    const textToSave = textArea.value;
    localStorage.setItem('savedText', textToSave);
});

submitButton.addEventListener('click', () => {
    localStorage.removeItem('savedText');
});
